module.exports = __webpack_public_path__ + "static/media/stars.741b66ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/stars.svg
// module id = 521
// module chunks = 21